/**
 * Collapsible sections for Shopify policy pages (Privacy, Terms, Returns).
 * Uses button toggles (not <details>) for reliable click handling.
 */
(function () {
  'use strict';

  var HEADING_LEVELS = ['H2', 'H3', 'H4'];

  function slugify(text, used) {
    var base =
      String(text || '')
        .toLowerCase()
        .replace(/['’]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 64) || 'section';
    var slug = base;
    var i = 2;
    while (used[slug]) {
      slug = base + '-' + i;
      i += 1;
    }
    used[slug] = true;
    return slug;
  }

  function pickHeadingTag(body) {
    for (var i = 0; i < HEADING_LEVELS.length; i++) {
      if (body.querySelector(HEADING_LEVELS[i].toLowerCase())) {
        return HEADING_LEVELS[i];
      }
    }
    return null;
  }

  function collectSections(body, headingTag) {
    var intro = [];
    var sections = [];
    var current = null;
    var nodes = Array.prototype.slice.call(body.childNodes);

    nodes.forEach(function (node) {
      var isHeading =
        node.nodeType === 1 && node.tagName === headingTag && node.textContent.trim();

      if (isHeading) {
        current = {
          title: node.textContent.trim(),
          heading: node,
          nodes: [],
        };
        sections.push(current);
        return;
      }

      if (current) {
        current.nodes.push(node);
      } else {
        intro.push(node);
      }
    });

    return { intro: intro, sections: sections };
  }

  function moveNodes(nodes, target) {
    nodes.forEach(function (node) {
      target.appendChild(node);
    });
  }

  function resolveContentRoot(body) {
    var rte = null;
    try {
      rte = body.querySelector(':scope > .rte');
    } catch (e) {
      rte = null;
    }
    if (!rte) {
      var children = body.children;
      if (children.length === 1 && children[0].classList.contains('rte')) {
        rte = children[0];
      }
    }
    if (rte) return rte;

    var onlyElement = null;
    var elementCount = 0;
    Array.prototype.forEach.call(body.children, function (child) {
      if (child.nodeType === 1) {
        elementCount += 1;
        onlyElement = child;
      }
    });
    if (elementCount === 1 && pickHeadingTag(onlyElement)) {
      return onlyElement;
    }

    return body;
  }

  function setOpen(section, panel, button, open) {
    section.classList.toggle('is-open', open);
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  }

  function enhance(container) {
    if (!container || container.dataset.chiijePolicyEnhanced === 'true') return;

    var body = container.querySelector('.shopify-policy__body');
    if (!body) return;

    var contentRoot = resolveContentRoot(body);
    var headingTag = pickHeadingTag(contentRoot);
    if (!headingTag) return;

    var parsed = collectSections(contentRoot, headingTag);
    if (parsed.sections.length < 2) return;

    container.dataset.chiijePolicyEnhanced = 'true';
    container.classList.add('chiije-policy');

    var usedSlugs = Object.create(null);
    var content = document.createElement('div');
    content.className = 'chiije-policy__content';

    if (parsed.intro.length) {
      var intro = document.createElement('div');
      intro.className = 'chiije-policy__intro';
      moveNodes(parsed.intro, intro);
      content.appendChild(intro);
    }

    var sectionControls = [];

    parsed.sections.forEach(function (sectionData, index) {
      var id = slugify(sectionData.title, usedSlugs);
      var section = document.createElement('div');
      section.className = 'chiije-policy__section';
      section.id = id;

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'chiije-policy__summary';
      button.id = id + '-trigger';
      button.setAttribute('aria-controls', id + '-panel');

      var label = document.createElement('span');
      label.className = 'chiije-policy__summary-label';
      label.textContent = sectionData.title;
      button.appendChild(label);

      var panel = document.createElement('div');
      panel.className = 'chiije-policy__section-body rte';
      panel.id = id + '-panel';
      panel.setAttribute('role', 'region');
      panel.setAttribute('aria-labelledby', button.id);

      if (sectionData.heading.parentNode) {
        sectionData.heading.parentNode.removeChild(sectionData.heading);
      }
      moveNodes(sectionData.nodes, panel);

      button.addEventListener('click', function () {
        var nextOpen = !section.classList.contains('is-open');
        setOpen(section, panel, button, nextOpen);
      });

      section.appendChild(button);
      section.appendChild(panel);
      content.appendChild(section);
      sectionControls.push({ section: section, panel: panel, button: button });

      var hashId = window.location.hash ? window.location.hash.slice(1) : '';
      var shouldOpen = hashId ? id === hashId : index === 0;
      setOpen(section, panel, button, shouldOpen);
    });

    function setAll(open) {
      sectionControls.forEach(function (item) {
        setOpen(item.section, item.panel, item.button, open);
      });
    }

    var toolbar = document.createElement('div');
    toolbar.className = 'chiije-policy__toolbar';

    var expandBtn = document.createElement('button');
    expandBtn.type = 'button';
    expandBtn.className = 'chiije-policy__toggle';
    expandBtn.textContent = 'Expand all';
    expandBtn.addEventListener('click', function () {
      setAll(true);
    });

    var collapseBtn = document.createElement('button');
    collapseBtn.type = 'button';
    collapseBtn.className = 'chiije-policy__toggle';
    collapseBtn.textContent = 'Collapse all';
    collapseBtn.addEventListener('click', function () {
      setAll(false);
    });

    toolbar.appendChild(expandBtn);
    toolbar.appendChild(collapseBtn);

    while (body.firstChild) {
      body.removeChild(body.firstChild);
    }

    body.appendChild(toolbar);
    body.appendChild(content);

    if (window.location.hash) {
      var target = document.getElementById(window.location.hash.slice(1));
      if (target) {
        window.requestAnimationFrame(function () {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }
  }

  function init() {
    document.querySelectorAll('.shopify-policy__container').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
